<div class="container mt-4 mb-4">
  <!-- Título principal -->
  <div class="row mt-5 mb-4">
    <div class="col-12">
      <h1 class="text-center">{{ 'resumen-general.titulo' | translate }}</h1>
    </div>
    <div *ngIf="fechaInicioSesion" class="col-12">
      <p class="text-center text-muted">
        Última vez de inicio de sesión: {{ fechaInicioSesion }}
      </p>
  </div>
  <!-- Sección de estadísticas -->
  <div class="row mb-5">
    <div class="col-12">
      <div class="d-flex justify-content-center">
        <div class="btn-actions" (click)="navegarA('/expediente')">
          <i class="fa fa-file-o" aria-hidden="true"></i>
          <p>{{ 'resumen-general.gestion-expedientes' | translate }}</p>
        </div>
        <div class="btn-actions" (click)="navegarA('/tramites')">
          <i class="fa fa-play" aria-hidden="true"></i>
          <p>{{ 'resumen-general.iniciar-proceso' | translate }}</p>
        </div>
        <div class="btn-actions" (click)="navegarA('/justino/bot')">
          <img
            src="assets/img/justino-mini-face.svg"
            alt="Bot Avatar"
            class="bot-avatar" />
          <p>{{ 'resumen-general.ayuda-justino' | translate }}</p>
        </div>
      </div>
    </div>
    <!-- Indicadores para Ciudadano -->
    <div *ngIf="esCiudadano" class="col-12">
      <div class="expedientes-stats-card">
        <div class="stat-item">
          <div class="stat-icon">
            <i class="fa fa-file-text-o" aria-hidden="true"></i>
            <span class="icon-badge icon-plus">+</span>
          </div>
          <div class="stat-content">
            <div class="stat-number">{{ graficas.revisados || 0 }}</div>
            <div class="stat-label">Expedientes<br>Revisados</div>
          </div>
        </div>
        <div class="stat-item">
          <div class="stat-icon">
            <i class="fa fa-file-text-o" aria-hidden="true"></i>
            <span class="icon-badge icon-minus">-</span>
          </div>
          <div class="stat-content">
            <div class="stat-number">{{ graficas.sinRevisar || 0 }}</div>
            <div class="stat-label">Expedientes<br>Sin Revisar</div>
          </div>
        </div>
        <div class="stat-item">
          <div class="stat-icon">
            <i class="fa fa-file-text-o" aria-hidden="true"></i>
            <span class="icon-badge icon-plus">+</span>
          </div>
          <div class="stat-content">
            <div class="stat-number">{{ graficas.totalExpedientes || 0 }}</div>
            <div class="stat-label">Total<br>Expedientes</div>
          </div>
        </div>
      </div>
    </div>
    <!-- Indicadores para Abogados -->
    <div *ngIf="esAbogado" class="col-12">
      <div class="expedientes-stats-card">
        <div class="stat-item">
          <div class="stat-icon">
            <i class="fa fa-file-text-o" aria-hidden="true"></i>
            <span class="icon-badge icon-plus">+</span>
          </div>
          <div class="stat-content">
            <div class="stat-number">{{ graficas.activos || 0 }}</div>
            <div class="stat-label">Expedientes<br>Activos</div>
          </div>
        </div>
        <div class="stat-item">
          <div class="stat-icon">
            <i class="fa fa-file-text-o" aria-hidden="true"></i>
            <span class="icon-badge icon-minus">-</span>
          </div>
          <div class="stat-content">
            <div class="stat-number">{{ graficas.cerrados || 0 }}</div>
            <div class="stat-label">Expedientes<br>Cerrados</div>
          </div>
        </div>
        <div class="stat-item">
          <div class="stat-icon">
            <i class="fa fa-file-text-o" aria-hidden="true"></i>
            <span class="icon-badge icon-plus">+</span>
          </div>
          <div class="stat-content">
            <div class="stat-number">{{ graficas.nuevos || 0 }}</div>
            <div class="stat-label">Nuevos Expedientes -<br>Último Mes</div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="esAbogado" class="col-12">
      <!-- Graficos de datos -->
      <div class="row mt-4">
        <!-- Grafica de barras (izquierda) -->
        <div class="col-md-6 mb-4">
          <div class="card h-100">
            <div class="card-body">
              <div style="position: relative; height: 400px;">
                <canvas #barChartCanvas></canvas>
              </div>
            </div>
          </div>
        </div>
        <!-- Grafica de torta (derecha) -->
        <div class="col-md-6 mb-4">
          <div class="card h-100">
            <div class="card-body">
              <div style="position: relative; height: 400px;">
                <canvas #pieChartCanvas></canvas>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Sección de procesos -->
  <div class="row">
    <!-- Columna izquierda: Contenido principal -->
    <div class="col-lg-8">
      <!-- Título de la sección -->
      <h4 class="section-title">{{ 'resumen-general.titulo-procesos' | translate }}</h4>
      <!-- Contenedor de búsqueda -->
      <div class="search-container">
        <div class="search-box">
          <i class="fa fa-search" aria-hidden="true"></i>
          <input type="text" placeholder="{{ 'resumen-general.buscar-proceso' | translate }}"
            [(ngModel)]="terminoBusqueda" (input)="filtrarProcesos()" />
        </div>
      </div>
      <!-- Lista de procesos -->
      <div class="processes-container">
        <div *ngFor="let proceso of procesosMostrados" class="process-item" (click)="toggleDetails(proceso)">
          <div class="process-header">
            <div class="process-info">
              <strong>{{ proceso.Etapa_Proceso.Etapa }}</strong>
              <span class="process-entity">- {{ proceso.Entidad.Acronimo }}</span>
              <span class="process-date">- {{ proceso.fechaCreacionFormateada }}</span>
            </div>
            <span class="badge" [ngClass]="getBadgeClass(proceso.Etapa_Proceso.Etapa)">
              {{ proceso.Etapa_Proceso.Etapa}}
            </span>
          </div>
          <!-- Detalles expandibles del proceso -->
          <div class="process-details" *ngIf="proceso.mostrarDetalles">
            <div class="process-detail-item">
              <i class="fa fa-file-text-o me-2"></i>
              <span><strong>{{ 'resumen-general.radicado' | translate }}:</strong> {{ proceso.Radicado }}</span>
            </div>
            <!-- Tabla Proceso -->
            <div class="contenedor-tabla w-100">
              <app-table
                [estiloEncabezado]="'height: auto !important;'"
                [datos]="[proceso]"
                [columnas]="columnas"
                [paginacion]="false">
              </app-table>
            </div>
            <!-- Timeline del proceso --> 
            <div class="timeline-container">
              <h6 class="timeline-title">{{ 'resumen-general.estado-proceso' | translate }}</h6>
              <div class="timeline">
                <div *ngFor="let etapa of proceso.etapasOrdenadas" class="timeline-step" [ngClass]="{
                  'active': etapa.Orden === proceso.Etapa_Proceso.Orden,
                  'completed': etapa.Orden < proceso.Etapa_Proceso.Orden
                  }">
                  <div class="circle"></div>
                  <span>{{ etapa.Etapa }}</span>
                </div>
              </div>
            </div>
            <!-- Detalle del estado actual -->
            <div class="estado-detalle">
              <h6>
                <i class="fa fa-info-circle me-2"></i>
                {{ 'resumen-general.detalle-estado' | translate }} | {{ proceso.Estado_Expediente.Estado }}
              </h6>
              <p>{{ proceso.Etapa_Proceso.Descripcion }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Columna derecha: Próximos eventos (Ciudadanos) o Comunicados (Abogados) -->
    <div class="col-lg-4">
      <div class="events-section">
        <!-- Sección de eventos para ciudadanos -->
        <div *ngIf="esCiudadano">
          <h4>{{ 'resumen-general.proximos-eventos' | translate }}</h4>
          <!-- Lista de eventos -->
          <div class="events-list">
            <div class="list-group">
              <div class="list-group-item" *ngFor="let evento of eventos">
                <div class="event-item">
                  <div class="event-info">
                    <i class="fa fa-calendar" aria-hidden="true"></i>
                    <strong>{{ formatearFechaEvento(evento.Fecha!) }}</strong>
                  </div>
                  <div class="event-time">
                    <i class="fa fa-clock-o" aria-hidden="true"></i>
                    <strong>{{ formatearHoraEvento(evento.Hora!) }}</strong>
                  </div>
                </div>
                <p>{{ evento.Entidad.Acronimo }} - {{ evento.Nombre_Evento }}</p>
              </div>
            </div>
          </div>
        </div>
        <!-- Sección de comunicados para abogados -->
        <div *ngIf="esAbogado">
          <h4>{{ 'resumen-general.comunicados' | translate }}</h4>
          <!-- Lista de comunicados -->
          <div class="events-list">
            <div class="list-group">
              <div class="list-group-item" *ngFor="let comunicado of comunicados">
                <div class="event-item">
                  <i class="fa fa-bullhorn" aria-hidden="true"></i>
                  <strong>{{ comunicado.Titulo }}</strong>
                </div>
                <p>{{ comunicado.Detalle }}</p>
              </div>
            </div>
          </div>
        </div>
        <!-- Sección del glosario -->
        <div class="glossary-section">
          <div class="border rounded">
            <i class="fa fa-book fa-2x mb-3 text-primary"></i>
            <p>
              {{ 'resumen-general.glosario-juridico' | translate }}
            </p>
            <button class="btn btn-dark"
              (click)="navegarA('/glosario-entidad')"
              [attr.aria-label]="'resumen-general.glosario-juridico-btn' | translate">
              <i class="fa fa-external-link me-2"></i>
              {{ 'resumen-general.glosario-juridico-btn' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<app-politica-tratamiento-datos-personales></app-politica-tratamiento-datos-personales>